import { render } from "./modal.vue?vue&type=template&id=51825fc0&ts=true"
import script from "./modal.ts?vue&type=script&lang=ts&external"
export * from "./modal.ts?vue&type=script&lang=ts&external"

import "./modal.scss?vue&type=style&index=0&lang=scss&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__